
import { defuFn } from '/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}

import cfg0 from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/app.config.ts"

export default /* #__PURE__ */ defuFn(cfg0, inlineConfig)
